import {apiServicePost} from "../services/api/api";

const state = () => ({
  gameConfig: {},
  gameResults: {},
  gameStatus: {},
  mainConfig: {},
  dailyReport: {},
  disabledConfirm: false,
  forceActiveRender: false,
});

const mutations = {
  // SOCKET_gameConfig(state, list) {
  //   state.gameConfig = list;
  // },
  setGameConfig(state, gameConfig) {
    state.gameConfig = gameConfig;
  },
  setGameResults(state, gameResults) {
    state.gameResults = gameResults;
  },
  SOCKET_gameStatus(state, list) {
    state.gameStatus = list;
  },
  SOCKET_mainConfig(state, message) {
    state.mainConfig = message;
  },
  SOCKET_GetDailyReport(state, message) {
    state.dailyReport = message;
  },
  setDisabledConfirm(state, list) {
    state.disabledConfirm = list;
  },
  setGameStatus(state, list) {
    state.gameStatus = list;
  },
};

const actions = {
  setDisabledConfirm(context, data) {
    context.commit('setDisabledConfirm', data);
  },
  async callGameConfig(context) {
    try {
      const {data} = await apiServicePost("luckyballs/game-config/get");
      context.commit('setGameConfig', data)
    } catch(error) {
      console.error("error fetching luckyballs/game-config/get", error);
    }
  },
  async callGameStatus(context) {
    try {
      const {data} = await apiServicePost("luckyballs/game/get");
      context.commit('setGameStatus', data.Data.BingoGameDisplay[0])
    } catch(error) {
      console.error("error fetching luckyballs/game-config/get", error);
    }
  },
  async callGameResults(context) {
    try {
      const {data} = await apiServicePost("luckyballs/game/results");
      context.commit('setGameResults', data)
    } catch(error) {
      console.error("error fetching luckyballs/game/results", error);
    }
  },
  setGameStatus(context, data) {
    context.commit('setGameStatus', data)
  }
};

const getters = {
  getGameConfig: state => state.gameConfig,
  getGameResults: state => state.gameResults,
  getGameStatus: state => state.gameStatus,
  getMainConfig: state => state.mainConfig,
  getDailyReport: state => state.dailyReport,
  getDisabledConfirm: state => state.disabledConfirm,
};

export default {
  state,
  actions,
  mutations,
  getters,
}
